import { memo, useCallback, useMemo } from 'react';

import { CheckIcon } from '@air/design-icons';
import { type DropdownMenuOption } from '@air/primitive-dropdown-menu';

import { SettingsButton } from '~/components/AssetModalV2/Content/Footer/components/SettingsButton';
import { usePDFContentControlsContext } from '~/components/AssetModalV2/Content/PDFContentControlsContextProvider';

export const PDFSettingsButton = memo(() => {
  const { showOriginal, setShowOriginal } = usePDFContentControlsContext();

  const handleSelectShowOriginal = useCallback(() => {
    setShowOriginal(!showOriginal);
  }, [showOriginal, setShowOriginal]);

  const options: DropdownMenuOption[] = useMemo(
    () => [
      {
        label: 'Show original PDF',
        onSelect: handleSelectShowOriginal,
        id: 'show-original-pdf',
        suffix: showOriginal ? <CheckIcon size="sm" className="ads:text-icon-primary text-blue-9" /> : null,
        type: 'item',
        truncate: false,
      },
    ],
    [showOriginal, handleSelectShowOriginal],
  );

  return <SettingsButton options={options} data-testid="PDF_SETTINGS_BUTTON" />;
});

PDFSettingsButton.displayName = 'PDFSettingsButton';
